import { PageHeader } from "@/components/PageHeader";
import { Badge } from "@/components/ui/Badge";
import { useAuth } from "@/contexts/AuthContext";
import * as shared from "@/styles/shared";
import { Role } from "@shared/types/models";
import { AlertTriangle, BadgeCheck, Mail, Server, Shield, User as UserIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AdminScrapingSchedulesTable } from "./AdminScrapingSchedulesTable";
import * as s from "./AdminSettingsPage.styles";

const AdminSettingsPage = () => {
  const { t } = useTranslation("adminSettings");
  const { user } = useAuth();

  return (
    <div className={s.container}>
      <PageHeader icon={Shield} title={t("title")} />

      <div className={shared.sectionCard}>
        <h2 className={shared.sectionHeading}>
          {user?.role === Role.ADMIN ? (
            <>
              <Shield className={`${s.icon} ${shared.iconPrimary}`} /> {t("adminAccess")}
            </>
          ) : (
            <>
              <UserIcon className={`${s.icon} ${shared.iconPrimary}`} /> {t("userProfile")}
            </>
          )}
        </h2>
        {user && (
          <div className={shared.formStack}>
            <p className={shared.muted}>
              <UserIcon className={s.inlineIcon} />
              <span className={s.label}>{t("name")}</span> {user.name || "N/A"}
            </p>
            <p className={shared.muted}>
              <Mail className={s.inlineIcon} />
              <span className={s.label}>{t("email")}</span> {user.email}
            </p>
            <p className={shared.muted}>
              <BadgeCheck className={s.inlineIcon} />
              <span className={s.label}>{t("role")}</span>{" "}
              <Badge variant={user.role === Role.ADMIN ? "success" : "default"} size="sm">
                {user.role}
              </Badge>
            </p>
          </div>
        )}
      </div>

      {user?.role === Role.ADMIN && (
        <>
          <AdminScrapingSchedulesTable />

          <div className={shared.sectionCard}>
            <h2 className={shared.sectionHeading}>
              <Server className={`${s.icon} ${shared.iconPrimary}`} /> {t("systemInformation")}
            </h2>
            <p className={shared.muted}>{t("systemInfoDesc")}</p>
          </div>
        </>
      )}

      {user?.role !== Role.ADMIN && (
        <div className={s.alertWarning}>
          <AlertTriangle className={s.alertIcon} />
          <p className={s.alertText}>{t("noAdminAccess")}</p>
        </div>
      )}
    </div>
  );
};

export { AdminSettingsPage };
